import CobrowseIO from "cobrowse-sdk-js"
import { mount, unmount } from "svelte"
import CobrowseConsentDialog from "./CobrowseConsentDialog.svelte"

export interface CobrowseUserData {
  extCrmId: string
}

export interface CobrowseOptions {
  license: string
  user?: CobrowseUserData
}

export async function initCobrowse(options: CobrowseOptions): Promise<void> {
  if (typeof window === "undefined") return

  CobrowseIO.license = options.license

  if (options.user) {
    CobrowseIO.customData = { ext_crm_id: options.user.extCrmId }
  } else {
    CobrowseIO.registration = false
  }

  CobrowseIO.redactedViews = ["[data-cs-mask]"]

  CobrowseIO.confirmSession = () =>
    new Promise<boolean>((resolve) => {
      const target = document.createElement("div")
      document.body.appendChild(target)

      try {
        let instance: Record<string, unknown>

        instance = mount(CobrowseConsentDialog, {
          target,
          props: {
            onAllow: () => {
              unmount(instance)
              target.remove()
              resolve(true)
            },
            onDeny: () => {
              unmount(instance)
              target.remove()
              resolve(false)
            },
          },
        })
      } catch (error) {
        target.remove()
        throw error
      }
    })

  try {
    await CobrowseIO.client()
    await CobrowseIO.start()
  } catch (error) {
    console.error("Cobrowse initialization failed:", error)
  }
}

export async function generateSessionCode(): Promise<string> {
  // client() is the SDK's idiomatic "wait until connected" call and is safe to
  // call multiple times. It guards against a race where the user requests a
  // session code before initCobrowse() has finished connecting.
  await CobrowseIO.client()
  return CobrowseIO.createSessionCode()
}
